export function formatGapTime(gap) {
  if (!gap || (gap.timeGap === null && gap.pointGap === null)) {
    return ""
  }
  
  // Handle simple numeric gap (backward compatibility)
  if (typeof gap === 'number') {
    // Don't display negative or zero gaps
    if (gap <= 0) {
      return ""
    }
    
    const totalSeconds = Math.floor(gap / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    
    // Format based on whether gap is less than 1 hour
    if (hours === 0) {
      return `+${minutes}:${seconds.toString().padStart(2, "0")}`
    } else {
      return `+${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    }
  }
  
  // Handle new gap structure with time and points
  let result = ""
  
  // Time gap
  if (gap.timeGap === 0) {
    result = "+0:00"
  } else if (gap.timeGap !== null && gap.timeGap > 0) {
    const totalSeconds = Math.floor(gap.timeGap / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    
    // Format based on whether gap is less than 1 hour
    if (hours === 0) {
      result = `+${minutes}:${seconds.toString().padStart(2, "0")}`
    } else {
      result = `+${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    }
  }
  
  // Point gap (add on new line if exists)
  if (gap.pointGap !== null && gap.pointGap !== 0) {
    const pointText = gap.pointGap > 0 ? `${gap.pointGap} pkt` : `+${Math.abs(gap.pointGap)} pkt`
    result = result ? `${result}\n${pointText}` : pointText
  }
  
  return result
}
